import { render, staticRenderFns } from "./searchPatente.vue?vue&type=template&id=1b043248&scoped=true&"
import script from "./searchPatente.vue?vue&type=script&lang=ts&"
export * from "./searchPatente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b043248",
  null
  
)

export default component.exports